/* @flow */
'use strict';

// # simple-statistics
//
// A simple, literate statistics system.

var ss = module.exports = {};

// Linear Regression
ss.linearRegression = require(22);
ss.linearRegressionLine = require(23);
ss.standardDeviation = require(57);
ss.rSquared = require(45);
ss.mode = require(33);
ss.modeFast = require(34);
ss.modeSorted = require(35);
ss.min = require(30);
ss.max = require(24);
ss.minSorted = require(31);
ss.maxSorted = require(25);
ss.sum = require(59);
ss.sumSimple = require(61);
ss.product = require(41);
ss.quantile = require(42);
ss.quantileSorted = require(43);
ss.iqr = ss.interquartileRange = require(20);
ss.medianAbsoluteDeviation = ss.mad = require(28);
ss.chunk = require(9);
ss.sampleWithReplacement = require(53);
ss.shuffle = require(54);
ss.shuffleInPlace = require(55);
ss.sample = require(47);
ss.ckmeans = require(10);
ss.uniqueCountSorted = require(64);
ss.sumNthPowerDeviations = require(60);
ss.equalIntervalBreaks = require(15);

// sample statistics
ss.sampleCovariance = require(49);
ss.sampleCorrelation = require(48);
ss.sampleVariance = require(52);
ss.sampleStandardDeviation = require(51);
ss.sampleSkewness = require(50);

// combinatorics
ss.permutationsHeap = require(38);
ss.combinations = require(11);
ss.combinationsReplacement = require(12);

// measures of centrality
ss.addToMean = require(2);
ss.geometricMean = require(18);
ss.harmonicMean = require(19);
ss.mean = ss.average = require(26);
ss.median = require(27);
ss.medianSorted = require(29);

ss.rootMeanSquare = ss.rms = require(46);
ss.variance = require(65);
ss.tTest = require(62);
ss.tTestTwoSample = require(63);
// ss.jenks = require('./src/jenks');

// Classifiers
ss.bayesian = require(3);
ss.perceptron = require(37);

// Distribution-related methods
ss.epsilon = require(14); // We make ε available to the test suite.
ss.factorial = require(17);
ss.bernoulliDistribution = require(4);
ss.binomialDistribution = require(5);
ss.poissonDistribution = require(39);
ss.chiSquaredGoodnessOfFit = require(8);

// Normal distribution
ss.zScore = require(66);
ss.cumulativeStdNormalProbability = require(13);
ss.standardNormalTable = require(58);
ss.errorFunction = ss.erf = require(16);
ss.inverseErrorFunction = require(21);
ss.probit = require(40);
ss.mixin = require(32);

// Root-finding methods
ss.bisect = require(6);
